import { createSlice } from '@reduxjs/toolkit';

const productSlice = createSlice({
  name: "product",
  initialState: {
    products: [],
    lastFetch: null,
    lastFetchToken: null,
    lastFetchClientId: null,
    showSuggestedPrice: false,
  },
  reducers: {
    setProducts(state, action) {
      state.products = action.payload.products;
      state.lastFetch = Date.now();
      state.lastFetchToken = action.payload.token ?? null;
      state.lastFetchClientId = action.payload.clientId ?? null;
    },
    resetProductCache(state) {
      state.lastFetch = null;
      state.lastFetchToken = null;
      state.lastFetchClientId = null;
    },
    toggleSuggestedPrice(state) {
      state.showSuggestedPrice = !state.showSuggestedPrice;
    },
  }
});

export const { setProducts, resetProductCache, toggleSuggestedPrice } = productSlice.actions;
export default productSlice.reducer;
